import { useNavigate } from 'react-router-dom'
import { useArchiveLazyLoadingRule, useLazyLoadingRules, useLazyLoadingRulesWithHistory } from '~/api/adm/lazy-loading-rules.api'
import { useScopePermissions } from '~/auth/useScopePermissions'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { PureAdmLazyLoadingPage } from './PureAdmLazyLoadingPage'

const LAZY_LOADING_PATH = '/monetization/one/lazy-loading'

export const AdmLazyLoadingPage: React.FunctionComponent = () => {
  const navigate = useNavigate()
  const breadcrumbs = useBreadcrumbs()
  /* Creating and archiving a rule are owner-only at the API — a rule is shared, so both are decisions
     about every stack that could reach for it. Reading the list stays open. */
  const { canCreate, canArchive, disabledReason } = useScopePermissions()

  const { data: lazyLoadingRules, isFetching, isError } = useLazyLoadingRules(true)
  const { data: lazyLoadingRulesHistory } = useLazyLoadingRulesWithHistory()
  const { mutateAsync: archiveLazyLoadingRule, isPending: isArchiving } = useArchiveLazyLoadingRule({
    successToast: 'Lazy loading rule archived',
    errorToast: 'Could not archive this lazy loading rule',
  })

  return (
    <PureAdmLazyLoadingPage
      lazyLoadingRules={lazyLoadingRules}
      isLoading={isFetching}
      isError={isError}
      breadcrumbs={breadcrumbs}
      onCreateRule={() => navigate(`${LAZY_LOADING_PATH}/new`)}
      onEditRule={(id: string) => navigate(`${LAZY_LOADING_PATH}/edit/${id}`)}
      lazyLoadingRulesHistory={lazyLoadingRulesHistory}
      onArchiveRule={(id: string) => archiveLazyLoadingRule({ id, archived: true })}
      isArchiving={isArchiving}
      onNavigateToArchived={() => navigate(`${LAZY_LOADING_PATH}/archived`)}
      canCreate={canCreate}
      canArchive={canArchive}
      permissionDisabledReason={disabledReason}
    />
  )
}
